import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import QChoiceChips, { type QChoiceChipsProps } from '.';

const useStyles = makeStyles()((theme) => ({
  typeSelection: {
    '& > label': {
      ...theme.typography.paragraphRegular,
    },
    '& >.MuiCard-root': {
      background: theme.palette.background.layer1,
      padding: 2,
      '& .MuiChip-outlined': {
        background: theme.palette.background.layer1,
        borderRadius: theme.spacing(1.5),
        '>.MuiChip-label': {
          padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        },
        '&.MuiChip-selected': {
          background: theme.palette.background.paper,
          color: theme.palette.text.secondary,
        },
      },
    },
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    background: theme.palette.background.default,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    alignItems: 'center',
    border: `1px solid ${theme.palette.border.light}`,
    boxShadow: 'none',
  },
}));

type Props = {
  text: string;
  className?: string;
  QChoiceChipsProps: QChoiceChipsProps<any>;
  showChoice?: boolean;
};

export default function QChoiceTextField(props: Props) {
  const { text, showChoice = true, QChoiceChipsProps, className } = props;
  const { classes } = useStyles();

  return (
    <Card className={classNames(classes.typeSelection, className)}>
      <Typography variant='paragraphRegular' lineHeight={2.5}>
        {text}
      </Typography>
      {showChoice ? (
        <Card>
          <QChoiceChips {...QChoiceChipsProps} />
        </Card>
      ) : (
        <Typography variant='paragraphRegular'></Typography>
      )}
    </Card>
  );
}
